require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-potzneusiedl.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-potzneusiedl");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-potzneusiedl!./.cache/json/betreuungseinrichtungen-neusiedl-potzneusiedl.json
// module id = 963
// module chunks = 231608221292675